export function AdminDashboard() {
  return (
    <>
      <p>
        This is the admin Dashboard..... Will include admin access, and same
        options as assitant admin, employees and users and employees,{" "}
      </p>
      <a href="https://www.google.com/">User Tuner</a>
    </>
  );
}
